
import React from 'react';
import { Label } from '@/components/ui/label';
import { FileText } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface EducationFieldProps {
  educationStatus: string;
  setEducationStatus: (status: string) => void;
  educationOptions: Array<{ value: string, label: string }>;
  error?: string;
}

const EducationField = ({ 
  educationStatus, 
  setEducationStatus, 
  educationOptions,
  error
}: EducationFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="educationStatus">
        Education Status <span className="text-red-500">*</span>
      </Label>
      <div className="relative">
        <FileText className="absolute left-3 top-3 h-5 w-5 text-gray-400 z-10" />
        <Select value={educationStatus} onValueChange={setEducationStatus} required>
          <SelectTrigger 
            className={`w-full pl-10 ${error ? 'border-red-500 ring-1 ring-red-500' : ''}`}
          >
            <SelectValue placeholder="Select your education qualification" />
          </SelectTrigger>
          <SelectContent className="max-h-[300px]">
            {educationOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {error && <p className="text-sm text-red-500 mt-1">{error}</p>}
    </div>
  );
};

export default EducationField;
